import { buildImageHandlerUrl, FULL_VIEW_IMAGE_RESIZE, type ImageResize } from '@gearbelt/global';

export function convertFullViewImageUrl(url: string): string {
  return convertImageUrl(url, FULL_VIEW_IMAGE_RESIZE);
}

/**
 * Turns a stored document image URL into a request to the image handler configured for this build
 * (`VITE_SIH_CF_URL`), resized when asked. Anything that is not a stored document, or a build without a handler,
 * comes back unchanged.
 */
export function convertImageUrl(url: string, options: ImageResize = {}): string {
  if (!url || typeof url !== 'string') {
    return url;
  }
  return buildImageHandlerUrl(import.meta.env.VITE_SIH_CF_URL, url, options);
}
